export default "__VITE_ASSET__CBoeBdrb__"